import React from 'react';
import PropTypes from 'prop-types';

const TierList = (props) => {
  const tiers = [];
  const stateObject = props.states[props.tooltipRegion];
  if (stateObject) {
    const tierObject = stateObject.tiers;
    const tierKeys = Object.keys(tierObject);
    for (let i = 0; i < tierKeys.length; i += 1) {
      tiers.push(
        <li className={tierKeys[i]} key={`${props.tooltipRegion}-${tierKeys[i]}`} >
          <div>
            <b> Tier {tierKeys[i].match(/[0-9]+/)[0]}</b>
            { tierObject[tierKeys[i]].map(value =>
              <div key={`${props.tooltipRegion}-${value}`}>
                {value}
              </div>,
            )}
          </div>
        </li>,
      );
    }
  } else {
    tiers.push(
      <li className="not-enough-data" key={`${props.tooltipRegion}-not-enough-data`}>
        Insufficient data for this state.
      </li>,
    );
  }

  return (
    <ul>
      <li className="state-title" key={`${props.tooltipRegion}-title`}>
        {props.tooltipRegion.replace('-', ' ')}
      </li>
      {tiers}
    </ul>
  );
};

TierList.defaultProps = {
  tooltipRegion: null,
};

TierList.propTypes = {
  tooltipRegion: PropTypes.string,
  states: PropTypes.shape({
  }).isRequired,
};

export default TierList;



// WEBPACK FOOTER //
// ./src-react/UsaMap/components/TierList.jsx